module.exports = __webpack_public_path__ + "img/ИФ-1(А)-018-m.ac358eb8.png";